import styled from 'styled-components';

import React, { Component, PropTypes } from 'react';

import Container from '../../../components/layouts/Container';
import HeaderAlert from './HeaderAlert';
import ProfileHeading from './ProfileHeading';
import MinimalProfileHeading from './MinimalProfileHeading';

const HeadingSection = styled.div`
  position: relative;
`;

class HeaderContainer extends Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    // return this.props.minimalMode !== nextProps.minimalMode;
    return true;
  }

  render() {
    const {
      bookmarkClick,
      bookmarkActive,
      title,
      alert,
      studs,
      subTitle,
      minimalMode,
      onStudClick,
      avatar,
      dashboardType
    } = this.props;

    return minimalMode ? (
      <Container>
        <MinimalProfileHeading {...this.props} />
      </Container>
    ) : (
      <HeadingSection>
        <ProfileHeading
          title={title}
          bookmarkClick={bookmarkClick}
          bookmarkActive={bookmarkActive}
          studs={studs}
          subTitle={subTitle}
          onStudClick={onStudClick}
          dashboardType={dashboardType}
          avatar={avatar}
        />
        {alert && <HeaderAlert content={alert} />}
      </HeadingSection>
    );
  }
}

HeaderContainer.propTypes = {
  bookmarkClick: PropTypes.func,
  bookmarkActive: PropTypes.bool,
  title: PropTypes.string,
  alert: PropTypes.string,
  studs: PropTypes.array,
  subTitle: PropTypes.string,
  minimalMode: PropTypes.bool,
  onStudClick: PropTypes.func,
  dashboardType: PropTypes.string,
  avatar: PropTypes.string
};

HeaderContainer.defaultProps = {
  // defaultProp: ''
};

export default HeaderContainer;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/HeaderContainer.js